import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { FilterSortTableDashboard } from "components/FilterSortTable/FilterSortTableDashboard";
import { ProjectProductTaskMeta } from "components/Task/ProjectProductTaskMeta";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";

const allowedFilters = [
  { key: "docCode", value: "Product Code" },
  { key: "productName", value: "Product Name" },
  { key: "partLotQuantity", value: "Quantity" },
  { key: "partLotDeadline", value: "Product Deadline" },
  { key: "taskTo", value: "Task To" },
  { key: "taskToDept", value: "Task To Department" },
  { key: "startDate", value: "Timeline Start Date" },
  { key: "endDate", value: "Timeline End Date" },
  { key: "taskDetails", value: "Task Detail" },
  { key: "acceptanceStatus", value: "Task Acceptance Status" },
  { key: "doneStatus", value: "Task Done Status" },
];

export const projectProductTaskListColumnsL = ({
  records,
  setOutputRecords,
}) => [
  {
    field: "expectedEndDate",
    headerName: "Product List (Lot wise)",
    flex: 1,
    sortable: false,
    renderHeader: (params) => (
      <FlexBox justifyContent="space-between" alignItems="center">
        <FilterSortTableDashboard
          records={records}
          setOutputRecords={setOutputRecords}
          allowedFilters={allowedFilters}
        />
        <Typography>Products</Typography>
      </FlexBox>
    ),

    renderCell: (params) =>
      params.row?.docCode ? (
        <ProjectProductTaskMeta row={params.row} />
      ) : (
        <Box>No Data</Box>
      ),
  },
];
